<template>
  <div class="basic-col"
    :style="subMatchKey == 0 ? { 'height': '105px !important', 'width': widthL + 'px !important'  } : { 'width': widthL + 'px !important' }">
    <!-- 'height': '70px !important',  -->
    <template v-if="subMatchKey == null || subMatchKey == 0">
      <div class="basic-wrap">
        <div class="row-item team-item" @click="enterAllBet(event)">
          <!--div class="team-logo"-->
            <!-- <img data-team="L" data-csid="undefined" src="https://image.gredfged.com/group1/M00/00/45/CgURtl8z6POAbzjGAAArvuQZPv8046.png" style="width: 22px; max-height: 24px; opacity: 1;"> -->
          <!--/div-->
          <div class="ellipsis-wrap">
            <div class="vrow no-wrap absolute-full">
              <div class="team-name home ellipsis allow-user-select" :class="teamColor(event, 'A', plytyp)" :title="getTeamCapt(event.tacapt, selMarket)" v-html="getTeamCapt(event.tacapt, selMarket)"></div>
              <span class="red-ball" :style="{ display : (mode !='morebet' && event.rbinfo && event.rbinfo.rca>0)? 'block':'none' }">
                <template v-if="mode !='morebet' && (event.rbinfo && event.rbinfo.rca>0)">
                  {{ event.rbinfo.rca }}
                </template>
              </span>
            </div>
          </div>
          <div class="score_game" v-if="(event.sptid==3 || event.sptid == 12 || event.sptid == 21) && event.rbinfo && event.rbinfo.score['PT']">
            {{ getScoreSet(event, 'A') }}
          </div>
          <div class="score"  :class="(event.sptid==7)?'spwidth':''" >
            <template v-if="mode !='morebet' && (event.rbinfo && event.rbinfo.scoa>=0) && (event.sptid == 1 || event.sptid == 2)">
              {{ event.rbinfo.scoa }}
            </template>
            <template v-else-if="mode =='morebet' && (['booking','corner'].includes(selMarket)) && event.sp_rbinfo && event.sp_rbinfo[specialEveId]">
              {{ event.sp_rbinfo[specialEveId].scoa }}
            </template>
            <template v-else-if="event.sptid > 2 && event.rbinfo">
              <template v-if="event.sptid == 13">
                {{ getScoreSet(event, 'A', true) }}  
              </template>
              <template v-else-if="event.sptid == 3 || event.sptid == 12 || event.sptid == 21"> <!--  || event.sptid == 23 -->
                <template v-if="event.rbinfo && event.rbinfo.score[event.rbinfo.st]">
                  {{ event.rbinfo.score[event.rbinfo.st]['scoa'] }}
                </template>
              </template>
              <template v-else>
                {{ getScoreSet(event, 'A') }}
              </template>
            </template>
          </div>
        </div>
        <div class="row-item team-item" @click="enterAllBet(event)">
          <!--div class="team-logo"-->
            <!-- <img data-team="H" data-csid="undefined" src="https://image.gredfged.com/group1/M00/00/24/CgURt17b6w6AN86EAAAWeUCLwpQ583.png" style="width: 22px; max-height: 24px; opacity: 1;"> -->
          <!--/div-->
          <div class="ellipsis-wrap">
            <div class="vrow no-wrap absolute-full">
              <!-- bold condition?? -->
              <div class="team-name away ellipsis allow-user-select " :class="teamColor(event, 'B', plytyp)" :title="getTeamCapt(event.tbcapt, selMarket)" v-html="getTeamCapt(event.tbcapt, selMarket)"></div>
              <span class="red-ball" :style="{ display : (mode !='morebet' && event.rbinfo && event.rbinfo.rcb>0) ? 'block':'none' }">
                <template v-if="mode !='morebet' && (event.rbinfo && event.rbinfo.rcb>0)">
                  {{ event.rbinfo.rcb }}
                </template>
              </span>
            </div>
          </div>
          <div class="score_game" v-if="(event.sptid==3  || event.sptid == 12 || event.sptid == 21) &&  event.rbinfo && event.rbinfo.score['PT']">
            {{ getScoreSet(event, 'B') }}
          </div>
          <div class="score" :class="(event.sptid==7)?'spwidth':''" >
            <template v-if="mode !='morebet' && (event.rbinfo && event.rbinfo.scob>=0) && (event.sptid == 1 || event.sptid == 2)">
              {{ event.rbinfo.scob }}
            </template>
            <template v-else-if="mode =='morebet' && (['booking','corner'].includes(selMarket)) && event.sp_rbinfo && event.sp_rbinfo[specialEveId]">
              {{ event.sp_rbinfo[specialEveId].scob }}
            </template>
            <template v-else-if="event.sptid > 2 && event.rbinfo">
              <template v-if="event.sptid == 13">
                {{ getScoreSet(event, 'B', true) }}  
              </template>
              <template v-else-if="event.sptid == 3 || event.sptid == 12 || event.sptid == 21"> <!--  || event.sptid == 23 -->
                <template v-if="event.rbinfo && event.rbinfo.score[event.rbinfo.st]">
                  {{ event.rbinfo.score[event.rbinfo.st]['scob'] }}
                </template>
              </template>
              <template v-else>
                {{ getScoreSet(event, 'B') }}
              </template>
            </template>
          </div>
          
        </div>
        <div class="row-item match-icon" v-show="selMarket == null">
          <div></div>
          <div class="more-info flex">
            <div class="neutral-wrap">
              <span class="icon-neutral q-icon c-icon" v-if="event.ha=='N'">
                <span class="path1"></span>
                <span class="path2"></span>
              </span>
            </div>
            <span class="yb-flex-center yb-hover-bg m-star-wrap-match" @click="favourite(event, isRB)">
              <i aria-hidden="true" class="icon-star q-icon c-icon" :class="{'active': event.isFavourite}"></i>
            </span>
            <div class="play-count-wrap vrow no-wrap">
              <!--template v-if="selectedBettype.sprtId == 'N15'">
                <span class="play-count">+0</span>
              </template>
              <template v-else-->
                <span class="play-count" @click="enterAllBet(event)">+{{ countAllBet(event, selectedShow) }}</span>
              <!--/template-->
              <span class="yb-flex-center">
                <div class="yb-icon-arrow"></div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'

import sportFavourite from '@/vue/mixins/favourite'
import sportAllBet from '@/vue/mixins/allBet'
import EventBus from '../../events/event-bus'
export default {
  mixins: [sportFavourite, sportAllBet],
  props: {
    selMarket: null,
    subMatchKey: {
      type: Number,
      default: 0,
    },
    event: null,
    rowspan: {
      type: String,
      default: '2'
    },
    classes: {
      type: String,
      default: ''
    },
    isos2: { //is othersportcommon2 template
      type: Boolean,
      default: false
    },
    plytyp: {
      type: String,
      default: ''
    },
    issc: { //is soccer 
      type: Boolean,
      default: false
    },
    subMatchKey: null,
    isAllBet: false,
    isRB: false,
    mode: null,
    widthL: {
      type: Number,
      default: 238,
    },
    specialEveId: null,
  },
  data() {
    return {
      btid: ['1', '2', '3'],
      sprtid: ['G1', 'N1'], //BK, SC
    }
  },
  computed: {
    ...mapGetters([
      'account',
      'sportAllBetLang',
      'sportTableLang',
      'market',
      'selectedMarket',
      'selectedBettype',
      'tvIconFlag',
      'selectedShow',
      'showFavEvents',
    ]),
  },
  methods: {
    getTeamCapt(teamCapt, selectedMarket) {
      var t = teamCapt
      if (selectedMarket == 'cs') {
        t = t + ' - ' + this.sportAllBetLang['ALL_BET.SUBHEADER_CS']
      }
      const parser = new DOMParser();
      return parser.parseFromString(t, "text/html").body.textContent;

      // return t
    },
    countAllBet(event, selectedShow) {
      var countCv = event.all
      return countCv;
    },
    teamColor(event, team, plytyp) {
      var cls = '';
      if (plytyp == "") {
        plytyp = 1;
      }
      if (event.od[plytyp] && event.od[plytyp][1] && !_.isUndefined(event.od[plytyp][1]['a']) && event.od[plytyp][1]['a']['hdp'] == '0') {
      } else if (event.od[plytyp] && event.od[plytyp][8] && !_.isUndefined(event.od[plytyp][8]['a']) && event.od[plytyp][8]['a']['hdp'] == '0') {
      } else {
        if (team == 'A' && event.od[plytyp] && event.od[plytyp][1] && !_.isUndefined(event.od[plytyp][1]['a']) && event.od[plytyp][1]['a']['fav'] == 'a') {
          cls = 'bold' //red
        } else if (team == 'A' && event.od[plytyp] && event.od[plytyp][8] && !_.isUndefined(event.od[plytyp][8]['a']) && event.od[plytyp][8]['a']['fav'] == 'a') {
          cls = 'bold' //red
        } else if (team == 'B' && event.od[plytyp] && event.od[plytyp][1] && !_.isUndefined(event.od[plytyp][1]['a']) && event.od[plytyp][1]['a']['fav'] == 'b') {
          cls = 'bold' //red
        } else if (team == 'B' && event.od[plytyp] && event.od[plytyp][8] && !_.isUndefined(event.od[plytyp][8]['a']) && event.od[plytyp][8]['a']['fav'] == 'b') {
          cls = 'bold' //red
        }
      }
      return cls
    },
    forecastNotIn(betTypId) {
      if (this.btid.indexOf(betTypId) > -1) {
        return true
      }
      return false
    },
    sportIdIN(sportId) {
      if (this.sprtid.indexOf(sportId) > -1) {
        return true
      }
      return false
    },
    openAllBetForm(event) {
      this.$store.dispatch('getSportAllBet', { event: event })
    },
    enterAllBet(event) {
      if(this.specialEveId) {
        event.eveid = event.sp[this.specialEveId].maineveid || this.specialEveId
      }
      this.$store.commit('RIGHT_BOARD_CHG', event)
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: (event.rbstatus==1) ? true : false,
        token: token.arr_8,
        loadTemplate:3  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
      })
    },
    getScoreSet(event, team, total=false){
      let teamA = 0
      let teamB = 0
      let hasRec= 0;
      if(event.rbinfo!=undefined && event.rbinfo.score!=undefined){
        _.forEach(event.rbinfo.score, function (data, key) {
          hasRec=1;
          if(event.sptid==3){
            if(key == 'SH' || key == 'PT'){
                teamA = data.scoa
                teamB = data.scob
            }/*
            if(key != 'PT' && key != event.rbinfo.st){
              if(data.scoa > data.scob){
                teamA += 1
              }else if(data.scoa < data.scob){
                teamB += 1
              }
            }*/
          }else if(event.sptid==23){
            // if(key != 'OT' && key != event.rbinfo.st){
              // teamA += parseInt(data.scoa)
              // teamB += parseInt(data.scob)
              if(key == 'FT'){
                teamA = parseInt(data.scoa)
                teamB = parseInt(data.scob)
              }
            // }
          }else if(event.sptid==14){
            // if(key != 'OT'){
              // teamA += parseInt(data.scoa)
              // teamB += parseInt(data.scob)
              if(key == 'FT'){
                teamA = parseInt(data.scoa)
                teamB = parseInt(data.scob)
              }
            // }
          }else if(event.sptid==12||event.sptid==21){
            if(total){
              // teamA += parseInt(data.scoa)
              // teamB += parseInt(data.scob)
              if(key == 'PT'){
                teamA = parseInt(data.scoa)
                teamB = parseInt(data.scob)
              }
            }else{
              if(key == 'SH'){
                teamA = parseInt(data.scoa)
                teamB = parseInt(data.scob)
              }/*if(key != event.rbinfo.st){
                if(data.scoa > data.scob){
                  teamA += 1
                }else if(data.scoa < data.scob){
                  teamB += 1
                }
              }*/
            }
          }else if(event.sptid==20||event.sptid==15){
            /*if(key != event.rbinfo.st){
              if(data.scoa > data.scob){
                teamA += 1
              }else if(data.scoa < data.scob){
                teamB += 1
              }
            }*/
            if(key == 'FT'){
              teamA = parseInt(data.scoa)
              teamB = parseInt(data.scob)
            }
          }else if(event.sptid==13){
            if(total){
              // teamA += parseInt(data.scoa)
              // teamB += parseInt(data.scob)
              if(key == 'FT'){
                teamA = parseInt(data.scoa)
                teamB = parseInt(data.scob)
              }
            // }else{
            //   if(key == 'S1' || key == 'S2'){
            //     teamA += parseInt(data.scoa)
            //     teamB += parseInt(data.scob)
            //   }
            }
          }else if(event.sptid==19){
            // teamA += parseInt(data.scoa)
            // teamB += parseInt(data.scob)
            if(key == 'FT'){
              teamA = parseInt(data.scoa)
              teamB = parseInt(data.scob)
            }
          }else if(event.sptid==7){
            // teamA = data.scoa
            // teamB = data.scob
            if(key == 'FT'){
              teamA = data.scoa
              teamB = data.scob
            }
          }
        })
      }
      if(hasRec==0){
          return '-'
      }
      return team == 'A' ? teamA : teamB
    },
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/sportTeamColumn.vue